import React, { useEffect, useState } from "react"
import ReactApexChart from "react-apexcharts"
import { useDispatch, useSelector } from "react-redux"
import { getBarChartData } from "store/actions"
// import getChartColorsArray from "../../../components/Common/ChartsDynamicColor";

const BarChart = ({ dataColors }) => {
  //   const spineareaChartColors = getChartColorsArray(dataColors);

  const { barChartData } = useSelector(state => ({
    barChartData: state.GetBarChart.barChart?.data
  }))
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getBarChartData())
  }, [])
  const [AirExport, setAirExport] = useState([])
  const [AirImport, setAirImport] = useState([])
  const [SeaExport, setSeaExport] = useState([])
  const [SeaImport, setSeaImport] = useState([])
  const [Category, setCategory] = useState([])

  useEffect(() => {
    let month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    let airExport = []
    let airImport = []
    let seaImport = []
    let seaExport = []
    let category = []
    const barChart = barChartData ? barChartData : []
    let len
    if (barChart?.length <= 6) {
      len = barChart?.length
    } else {
      len = 6
    }
    for (let i = 0; i < len; i++) {
      if ((barChart[i]?._id?.month !== '') && (barChart[i]?._id.month !== null) && (barChart[i]?._id.month !== undefined)) {
        airExport[i] = barChart[i]?.countByAirExport || 0
        airImport[i] = barChart[i]?.countByAirImport || 0
        seaExport[i] = barChart[i]?.countByShipExport || 0
        seaImport[i] = barChart[i]?.countByShipImport || 0
        category[i] = month[(barChart[i]?._id.month.substring(5, 7)) - 1]
      }
    }
    setAirExport(airExport)
    setAirImport(airImport)
    setSeaExport(seaExport)
    setSeaImport(seaImport)
    setCategory(category)
  }, [barChartData])

  const series = [
    {
      name: 'Sea Export',
      data: SeaExport
    },
    {
      name: 'Sea Import',
      data: SeaImport
    },
    {
      name: 'Air Export',
      data: AirExport
    },
    {
      name: 'Air Import',
      data: AirImport
    },
  ]
  const options = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    colors: ['#969696', '#ECD142', '#FF9649','#E7415E'],
    grid: {
      borderColor: "#f1f1f1",
    },
    xaxis: {
      categories: Category,
    },
    
  }

  return (
    <ReactApexChart options={options} series={series} type="bar" height="300" />
  )
}

export default BarChart
